module.exports = __webpack_public_path__ + "static/img/80016A_R_2_3_4_20171015_fit.1af8715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80016A_R_2_3_4_20171015_fit.png
// module id = Okys
// module chunks = 0